import { useEffect } from 'react';

import { refreshUser } from '@/features/user/store/user.actions';
import { UserInformation } from '@/features/kyc/components/userInformation/UserInformation';
import { KycInfos } from '@/features/kyc/components/kyc-infos/KycInfos';
import { KycDocuments } from '@/features/kyc/components/kyc-documents/KycDocuments';
import { UserKYCReview } from '@/features/kyc/components/kyc-actions/UserKYCReview';
import { useKycInfos } from '@/features/kyc/hooks/useKycInfos';

import { useAppDispatch } from '@/hooks/redux-helpers';

import { findUsersKycDocuments } from '@/features/kyc/store/actions/kyc-profile.actions';

import { useProfileContext } from '@/features/context/ProfileContext';

export const KycKybPage = () => {
  const dispatch = useAppDispatch();
  const { user } = useProfileContext();
  const { pageTitle } = useKycInfos();

  useEffect(() => {
    dispatch(refreshUser(user.userId, true));
  }, [dispatch, user.userId]);

  useEffect(() => {
    user && dispatch(findUsersKycDocuments(user));
  }, [dispatch, user]);

  return (
    <div className="flex flex-col gap-7 mt-6">
      <div className="flex items-center justify-between">
        <h4 className="typo-h4-bold text-secondary">{pageTitle}</h4>
        <UserKYCReview />
      </div>
      <KycInfos />
      <UserInformation />
      <KycDocuments />
    </div>
  );
};
